const version = process.env.APP_VERSION

export default {
  online: {
    domainList: [
      'c.didi-food.com',
      'pre-c.didi-food.com',
      'pay.didiglobal.com',
      'pay-pre.didiglobal.com',
    ], // 挑战应答
    env: 'ame', // test: 测试环境、CN: 国内、AME: 美东、SOFI：国际化金融专用、G：非以上环境的情况下传该值
    bizId: '52e3646a5fd587ba08d0156c11a09665', // 申请流程参考：https://cooper.didichuxing.com/knowledge/share/book/vFvlEjjW9EVT/2202825325844
    wsgenvAppId: '02040207', // wsgenv appId，安全侧提供
    appVer: version,
    os: '4', // WEB环境
    byQuery: true, // 挑战应答参数通过query携带
  },
}
